import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentId:0
  },
  getters: {
  },
  mutations: {
    editCurrent(state,id){
      state.currentId=id
    }
  },
  actions: {
  },
  modules: {
  }
})
